import Utils from 'services/utils';

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * LabelsApi class.
 */
export default class LabelsApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.listUrl = Utils.buildApiUrl('labels.list');
    }

    /**
     * Fetch labels
     * @returns {promise}
     */
    fetch() {
        return this.$http.get(this.listUrl).then(responseDataExtractor);
    }

    entity(labelId) {
        const url = Utils.buildApiUrl('labels.entity', { labelId });
        return this.$http.get(url).then(responseDataExtractor);
    }

    /**
     * Search labels by query
     * @param {string} query - Search pattern
     * @param {Object} metadata - Request settings, like: limit, ofset etc.
     * @returns {promise}
     */
    search(query, metadata = {}) {
        return this.$http.get(
            this.listUrl,
            {
                params: {
                    query: `${query}*`,
                    ...metadata
                }
            })
            .then(responseDataExtractor);
    }

    /**
     * Create label
     * @param {String} name - Title of label
     * @returns {promise}
     */
    create(name) {
        return this.$http.post(this.listUrl, { name }).then(responseDataExtractor);
    }

    /**
     * Update label by id
     * @params {String} labelId - Label id
     * @params {String} name - Label title
     * @returns {promise}
     */
    update(labelId, name) {
        const url = Utils.buildApiUrl('labels.entity', { labelId });
        return this.$http.put(url, { name }).then(responseDataExtractor);
    }

    /**
     * Remove label by id
     * @param {String} labelId - label id
     * @returns {promise}
     */
    remove(labelId) {
        const url = Utils.buildApiUrl('labels.entity', { labelId });
        return this.$http.delete(url).then(responseDataExtractor);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/labels/labels.service.js